import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import {
  LoadFolderPermissionLogParams,
  loadFolderPermissionLog,
} from '~src/services/api/actionLogs';
import { DbFolderPermissionActionLog } from '~src/types/db';
import { useProjectId } from '../useProjectId';

type UseFolderPermissionActionLogProps = Omit<
  LoadFolderPermissionLogParams,
  'projectId'
>;

interface ReturnType {
  logs: DbFolderPermissionActionLog[];
  totalCount: number;
}

export const useFolderPermissionActionLog = (
  {
    skip,
    take,
    before,
    after,
    response_type,
  }: UseFolderPermissionActionLogProps = {},
  queryConfig: QueryConfig<ReturnType, AxiosError> & {
    enabled?: boolean;
  }
) => {
  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const folderPermissionActionLogQuery = useQuery<ReturnType, AxiosError>(
    [
      'folderPermissionActionLog',
      {
        projectId: Number(projectId),
        skip,
        take,
        before,
        after,
        response_type,
      },
    ],
    loadFolderPermissionLog,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return folderPermissionActionLogQuery;
};
